"use client";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";
import type { ReactNode } from "react";
import { Anchor, Button, useServiceContext } from "../..";

interface Props {
	children: ReactNode;
	icon?: IconProp;
	href?: string;
	variant?: "link" | "outlined" | "contained";
}

export function ContactButton({ children, icon, href, variant = "link" }: Props) {
	const { onOpenHandler, chatHandler, chatAvailable } = useServiceContext();

	return chatAvailable ? (
		<Button
			variant={variant}
			starticon={icon}
			onClick={async () => {
				onOpenHandler();
				await chatHandler();
			}}
		>
			{children}
		</Button>
	) : (
		<Anchor href={href ?? "/contacts"} target="_blank" starticon={icon} variant={variant}>
			{children}
		</Anchor>
	);
}
